export const IG_LINK= "https://instagram.com/the_island_festival?igshid=YmMyMTA2M2Y="

export const TIKTOK_LINK = "https://www.tiktok.com/@theislandfestival?_t=8kcO0fGIxSS&_r=1"